export class Column {
    key: string;
    dictionaryKey: string;
}

export enum ColumnEditorMode {
    TRANSPORT = 'TRANSPORT', VISITOR = 'VISITOR'
}

export const ColumnDefinitions = {
    transportColumns: new Array<Column>(
        { key: 'hint', dictionaryKey: 'tmc-yard.entity.transport.hint-label' },
        { key: 'carrier', dictionaryKey: 'tmc-yard.entity.transport.masterdata.carrier' },
        { key: 'supplier', dictionaryKey: 'tmc-yard.entity.transport.masterdata.supplier' },
        { key: 'identifier', dictionaryKey: 'tmc-yard.entity.transport.identifier' },
        { key: 'trailer-identifier', dictionaryKey: 'tmc-yard.entity.transport.masterdata.firstLoadCarrier.trailerIdentifier' },
        { key: 'name', dictionaryKey: 'tmc-yard.entity.transport.name' },
        { key: 'visitStatusDict', dictionaryKey: 'tmc-yard.entity.transport.status' },
        { key: 'currentStation', dictionaryKey: 'tmc-yard.entity.transport.current-station' },
        { key: 'nextStation', dictionaryKey: 'tmc-yard.entity.transport.next-station' },
        { key: 'string1', dictionaryKey: 'tmc-yard.entity.transport.masterdata.string1' },
        { key: 'string2', dictionaryKey: 'tmc-yard.entity.transport.masterdata.string2' },
        { key: 'processingTime', dictionaryKey: 'tmc-yard.entity.transport.processing-time' },
        { key: 'waitingTime', dictionaryKey: 'tmc-yard.entity.transport.waiting-time' },
        { key: 'start', dictionaryKey: 'tmc-yard.entity.transport.timing.start' },
        { key: 'reference', dictionaryKey: 'tmc-yard.entity.transport.masterdata.firstLoadCarrier.orderReference' },
        { key: 'options', dictionaryKey: 'tmc-yard.entity.transport.options' },
        { key: 'cargo', dictionaryKey: 'tmc-yard.entity.transport.masterdata.firstLoadCarrier.cargo' },
        { key: 'planningDate', dictionaryKey: 'tmc-yard.entity.transport.planning-date' },
        { key: 'messagingResources', dictionaryKey: 'tmc-yard.entity.transport.messaging-resources' },
        { key: 'currentPositionStatus', dictionaryKey: 'tmc-yard.entity.transport.current-position-status' },
        { key: 'currentPositionStart', dictionaryKey: 'tmc-yard.entity.transport.current-position-start' },
        { key: 'currentPositionStatusStart', dictionaryKey: 'tmc-yard.entity.transport.current-position-status-start' },
        { key: 'currentPositionDuration', dictionaryKey: 'tmc-yard.entity.transport.current-position-duration' },
        { key: 'currentPositionStatusDuration', dictionaryKey: 'tmc-yard.entity.transport.current-position-status-duration' },
        { key: 'registrationCode', dictionaryKey: 'tmc-yard.entity.transport.registration-code' },
        { key: 'currentPositionCargo', dictionaryKey: 'tmc-yard.entity.transport.current-position-cargo' },
        { key: 'currentPositionHint', dictionaryKey: 'tmc-yard.entity.transport.current-position-hint' },
        { key: 'processingTimeCurrentProcessing', dictionaryKey: 'tmc-yard.entity.transport.processing-time-current-processing' },
        { key: 'beginReal', dictionaryKey: 'tmc-yard.entity.transport.timing.relevantStart' },
        { key: 'currentRoutingPositionOptionValues', dictionaryKey: 'tmc-yard.entity.transport.current-routing-position-option-values' },
        { key: 'nextProcessingPositionOptionValues', dictionaryKey: 'tmc-yard.entity.transport.next-processing-position-option-values' },
        { key: 'internal', dictionaryKey: 'tmc-yard.entity.transport.internal' },
        { key: 'vehicle-type', dictionaryKey: 'tmc-yard.entity.transport.masterdata.vehicleType' },
        { key: 'loading-type', dictionaryKey: 'tmc-yard.entity.transport.loading-type' },
        { key: 'currentPositionIfsStatus1', dictionaryKey: 'tmc-yard.entity.transport.currentPositionIfsStatus1' },
        { key: 'currentPositionIfsStatus2', dictionaryKey: 'tmc-yard.entity.transport.currentPositionIfsStatus2' },
        { key: 'transportOptionParameterValues', dictionaryKey: 'tmc-yard.entity.transport.transport-option-parameter-values' },
        { key: 'leaveDate', dictionaryKey: 'tmc-yard.entity.transport.leaveDate' },
        { key: 'phone', dictionaryKey: 'tmc-yard.entity.transport.phone' }
    ),
    visitorColumns: new Array<Column>(
        { key: 'hint', dictionaryKey: 'tmc-visit.entity.visit.hint' },
        { key: 'name', dictionaryKey: 'tmc-visit.entity.visit.name' },
        { key: 'firstname', dictionaryKey: 'tmc-visit.entity.visit.firstname' },
        { key: 'company', dictionaryKey: 'tmc-visit.entity.visit.company' },
        { key: 'visitedPerson', dictionaryKey: 'tmc-visit.entity.visit.visitedperson' },
        { key: 'reason', dictionaryKey: 'tmc-visit.entity.visit.reason' },
        { key: 'notes', dictionaryKey: 'tmc-visit.entity.visit.notes' },
        { key: 'numberPlate', dictionaryKey: 'tmc-visit.entity.visit.numberplate' },
        { key: 'start', dictionaryKey: 'tmc-visit.entity.visit.start' },
        { key: 'supplementaryEquipments', dictionaryKey: 'tmc-visit.entity.visit.supplementaryEquipments' },
    )
};

